"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'Spectrum';
exports.packageGroup = 'spectrum';
exports.apiPathGroup = 'spectra';
exports.routerPathGroup = 'spectrum';
